var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "employee-association-container" }, [
    _c("h2", [_vm._v("Employee Association Code")]),
    _c("p", { staticClass: "mt-2" }, [
      _vm._v(
        "When your employees make accounts have them use this to associate to your business"
      ),
    ]),
    _c(
      "div",
      { staticClass: "code-container" },
      _vm._l(_vm.code, function (digit, index) {
        return _c("div", { key: index, staticClass: "digit-box" }, [
          _vm._v(" " + _vm._s(digit) + " "),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }